module.exports = __webpack_public_path__ + "static/Q1_2024_Announcement_Financial_Results-3decb47f44639dba3fe3737b26f1ecc9.pdf";